import Accomodations from '~/js/views/resorts/components/Accomodations';
import '~/js/views/resorts/includes/scroll-below';
import '~/js/modules/stickyNav';

const internals = {
    filters: {
        roomCategories: ['LV', 'GA', 'PO', 'GO', 'MO', 'PF', 'VS']
    }
};

const reactAccomodations = document.querySelector('#rct-accomodations');

ReactDOM.render(<Accomodations filters={internals.filters} roomLevel="AT THE MEDITERRANEAN OCEANVIEW VILLAGE" />, reactAccomodations);
